import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';
import { UserDefined } from "@docma-mm-core/user-defined/user-defined";
import { firstValueFrom } from "rxjs";

@UntilDestroy()
@Injectable()
export class GridItemSelectionService extends SelectionService<UserDefined> {


  constructor() {
    super();

    this.itemSelectionChange
    .pipe(untilDestroyed(this))
    .subscribe(fi => {
      fi.item.isChecked = fi.selected
    });

    this.selectedItems
    .pipe(untilDestroyed(this))
    .subscribe(async i => {
      if(i?.length === 0 && await firstValueFrom(this.selectionMode)) {
        this.stopSelectionMode();
      }})
  }

  toggleSelection(specItem: any) {
    if (specItem.isChecked) {
      this.deselectItem(specItem);
    } else {
      this.selectItem(specItem);
    }
  }

}
